export const PIXABAY_IMAGE_QUERY_KEY = 'pixabayImageQuery';
export const PIXABAY_VIDEO_QUERY_KEY = 'pixabayVideoQuery';
export const DefaultPixabayApiKey = import.meta.env.VITE_DEFAULT_PIXABAY_API_KEY;
